require("dynamic-module-registry").get("livechatConfig");
window.lpTag = {};
typeof window.lpTag._tagCount === "undefined"
  ? ((window.lpTag = {
      site: "62573324",
      section: window.lpTag.section || "",
      tagletSection: window.lpTag.tagletSection || null,
      autoStart: window.lpTag.autoStart !== !1,
      ovr: window.lpTag.ovr || {},
      _v: "1.8.0",
      _tagCount: 1,
      protocol: "https:",
      events: {
        bind: function (t, e, i) {
          window.lpTag.defer(function () {
            window.lpTag.events.bind(t, e, i);
          }, 0);
        },
        trigger: function (t, e, i) {
          window.lpTag.defer(function () {
            window.lpTag.events.trigger(t, e, i);
          }, 1);
        },
      },
      defer: function (t, e) {
        e === 0
          ? ((this._defB = this._defB || []), this._defB.push(t))
          : e === 1
            ? ((this._defT = this._defT || []), this._defT.push(t))
            : ((this._defL = this._defL || []), this._defL.push(t));
      },
      load: function (t, e, i) {
        var n = this;
        setTimeout(function () {
          n._load(t, e, i);
        }, 0);
      },
      _load: function (t, e, i) {
        var n = t;
        t ||
          (n =
            this.protocol +
            "//" +
            (this.ovr && this.ovr.domain ? this.ovr.domain : "lptag.liveperson.net") +
            "/tag/tag.js?site=" +
            this.site);
        var a = document.createElement("script");
        a.setAttribute("charset", e ? e : "UTF-8");
        i && a.setAttribute("id", i);
        a.setAttribute("src", n);
        document.getElementsByTagName("head").item(0).appendChild(a);
      },
      init: function () {
        this._timing = this._timing || {};
        this._timing.start = new Date().getTime();
        var t = this;
        window.attachEvent
          ? window.attachEvent("onload", function () {
              t._domReady("domReady");
            })
          : (window.addEventListener(
              "DOMContentLoaded",
              function () {
                t._domReady("contReady");
              },
              !1,
            ),
            window.addEventListener(
              "load",
              function () {
                t._domReady("domReady");
              },
              !1,
            ));
        typeof window._lptStop === "undefined" && this.load();
      },
      start: function () {
        this.autoStart = !0;
      },
      _domReady: function (t) {
        this.isDom ||
          ((this.isDom = !0),
          this.events.trigger("LPT", "DOM_READY", {
            t: t,
          }));
        this._timing[t] = new Date().getTime();
      },
      vars: window.lpTag.vars || [],
      dbs: window.lpTag.dbs || [],
      ctn: window.lpTag.ctn || [],
      sdes: window.lpTag.sdes || [],
      hooks: window.lpTag.hooks || [],
      ev: window.lpTag.ev || [],
    }),
    window.lpTag.init())
  : (window.lpTag._tagCount += 1);

